/** @file guideText: one server guide as markdown text (`GET /api/v1/guides/{topic}`). */

/** The guide `topic` of the server at `url`; throws on a non-2xx status. */
export async function guideText(url: string, topic: string, fetchFn: typeof fetch = fetch): Promise<string> {
  const res = await fetchFn(`${url.replace(/\/+$/, '')}/api/v1/guides/${encodeURIComponent(topic)}`, { credentials: 'include' });
  if (!res.ok) throw new Error(`guide ${topic}: HTTP ${String(res.status)}`);
  return res.text();
}
